import { ErrorState, LoadingState } from "../../components/StatusView";
import { GlobalNetworkEmptyState } from "../../features/network/GlobalNetworkEmptyState";
import { GlobalNetworkManagement } from "../../features/network/GlobalNetworkManagement";
import { useGlobalNetwork } from "../../features/network/globalNetworkHooks";

import { AdminNetworkTelemetryPanel } from "../../features/network/NetworkTelemetry";

export function ConsoleGlobalNetworkPage() {
  return (
    <>
      <AdminNetworkTelemetryPanel />
      <GlobalNetworkRecord />
    </>
  );
}

function GlobalNetworkRecord() {
  const { state, reload } = useGlobalNetwork();

  if (state.status === "loading") {
    return <LoadingState label="Loading global network…" />;
  }

  if (state.status === "error") {
    return <ErrorState message={state.message} onRetry={reload} />;
  }

  return state.data.network === null ? (
    <div className="console-page">
      <GlobalNetworkEmptyState onCreated={reload} />
    </div>
  ) : (
    <GlobalNetworkManagement network={state.data.network} />
  );
}
